import React, {useLayoutEffect} from 'react';
import {SPP_RECOMMENDATION_TYPES} from '../../../../constants/SolutionType';
import {useReviewContext} from '../../../../contexts/ReviewContext';
import {recommendFieldsType} from '../recommendFields';
import {useRecommendContext} from '../CreateRecommendHelpers';
import Loading from '../../../../components/Loading/Loading';
import AutoField, {ActionType} from '../../../../components/AutoForm/AutoFieldNew';
import {useAutoForm} from '../../../../components/AutoForm/useAutoForm';
import {loadSppRecommends} from '../../hooks/createRecommendHooks';

export {loadSppRecommends};

export const RecommendSPPOptions: React.FC<{
  isSubmitting: boolean;
}> = (props) => {
  const {isSubmitting} = props;
  const {values, setFieldValue} = useAutoForm<recommendFieldsType>();
  const {recommendDetails} = useRecommendContext();
  const {reviewDetails, loadingReview} = useReviewContext();

  useLayoutEffect(() => {
    loadSppRecommends({
      recommendDetails,
      setFieldValue,
    });
  }, [values.how, recommendDetails, reviewDetails]);

  if (loadingReview) {
    return <Loading />;
  }

  const options = [
    {
      label: SPP_RECOMMENDATION_TYPES.ExecutionOnly,
      value: SPP_RECOMMENDATION_TYPES.ExecutionOnly,
    },
    {
      label: SPP_RECOMMENDATION_TYPES.Advised,
      value: SPP_RECOMMENDATION_TYPES.Advised,
    },
  ];

  return (
    <AutoField
      key={values.sppType}
      field={{
        type: ActionType.radioGroup,
        disabled: isSubmitting,
        boldLabel: true,
        id: 'sppType',
        options,
        label: 'Is this instruction',
      }}
    />
  );
};
